import { ErrandResponse } from '@backend/schemas/src/errands'
import { useNavigate } from '@tanstack/react-router'

import DataTable from '../data-table'
import { useErrandsTable } from './columns'

type Props = {
  errands: ErrandResponse[]
}

const ErrandsTable = ({ errands }: Props) => {
  const navigate = useNavigate()
  const columns = useErrandsTable(errands, id => navigate({ to: '/errands/$id', params: { id } }))

  return (
    <DataTable
      columns={columns}
      data={errands}
      getRowProps={row => ({
        className: 'cursor-pointer',
        onClick: () => navigate({ to: '/errands/$id', params: { id: row.id } }),
      })}
    />
  )
}

export default ErrandsTable
